module.exports = __webpack_public_path__ + "static/UploadAPI-b152a65e98b9cd6f93befb98c8743e40.png";